import { PropsWithChildren, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Link as RRLink } from "react-router";
import { Box, Link, Paper, Stack, Typography } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { ExamDateDto, OnlinePaymentStatus } from "api";
import { PageHeader } from "./PageHeader";
import { Stepper } from "./Stepper";
import { ExamCard } from "./ExamCard";

export const RegistrationStepPageLayout = ({
  stepIndex,
  selectedExam,
  subTitle,
  completed,
  backToHome,
  examCardCta,
  hideStepper,
  paymentStatus,
  examCardPlaceholder,
  priceOverride,
  currencyOverride,
  children,
}: PropsWithChildren<{
  stepIndex: number;
  selectedExam?: ExamDateDto;
  subTitle?: string;
  completed?: boolean;
  backToHome?: boolean;
  examCardCta?: ReactNode;
  hideStepper?: boolean;
  paymentStatus?: OnlinePaymentStatus;
  examCardPlaceholder?: boolean;
  priceOverride?: number | null;
  currencyOverride?: string | null;
}>) => {
  const { t } = useTranslation();

  return (
    <>
      <PageHeader sx={{ mb: 8 }}>{t("common.title")}</PageHeader>
      {!hideStepper && (
        <Stepper stepIndex={stepIndex} sx={{ mb: 8 }} completed={completed} />
      )}
      {subTitle && (
        <Typography
          variant="h3"
          sx={{ mb: 8, textAlign: completed ? "center" : "left" }}
        >
          {subTitle}
        </Typography>
      )}

      {backToHome && (
        <Link
          component={RRLink}
          to="/"
          underline="hover"
          sx={{ display: "inline-flex", mb: 2 }}
        >
          <ArrowBackIosIcon /> {t("common.goToHome")}
        </Link>
      )}

      {selectedExam || examCardPlaceholder ? (
        <Stack
          direction={{ md: "row-reverse" }}
          sx={{ justifyContent: "space-between", gap: 2, mb: 8 }}
        >
          <Box
            sx={{
              height: "fit-content",
              width: { md: "33%" },
              position: { md: "sticky" },
              top: "80px",
            }}
          >
            <ExamCard
              exam={selectedExam}
              cta={examCardCta}
              paymentStatus={paymentStatus}
              priceOverride={priceOverride}
              currencyOverride={currencyOverride}
            />
          </Box>
          <Box sx={{ width: { md: "65%" }, position: "relative" }}>
            <Paper component={Box} sx={{ p: { xs: 2, md: 3 }, minHeight: 350 }}>
              {children}
            </Paper>
          </Box>
        </Stack>
      ) : (
        <Box sx={{ mb: 8, position: "relative" }}>{children}</Box>
      )}
    </>
  );
};
